import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { OWNERS, IMAGES } from "../../mock";

const promises = [
  "Built to code, made to last",
  "Transparent pricing, no surprises",
  "Respect for your home and schedule",
];

export default function AboutTeaser() {
  return (
    <section className="py-24 bg-[#f2ede4] overflow-hidden">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="reveal-left order-2 lg:order-1">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#2f9fe6]" />
              <span className="text-[#2f9fe6] tracking-[0.24em] text-xs font-semibold uppercase">About Us</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f2740] leading-tight mb-4">
              Meet {OWNERS.names}
            </h2>
            <p className="text-[#5a6570] text-lg leading-relaxed mb-8">{OWNERS.text}</p>
            <ul className="space-y-3 mb-10">
              {promises.map((p) => (
                <li key={p} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-[#2f9fe6] flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-white" />
                  </span>
                  <span className="text-[#0f2740] font-medium">{p}</span>
                </li>
              ))}
            </ul>
            <Link to="/about" className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#0f2740] text-white font-semibold hover:bg-[#16324f] transition-all">
              More About Us
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>

          <div className="relative reveal-right order-1 lg:order-2">
            <div className="shape-blob">
              <img src="/assets/team.png" alt="Andrew and Slava reviewing renovation plans with a client" className="w-full h-[520px] object-cover" />
            </div>
            <div className="absolute -bottom-4 -right-2 sm:right-8 shape-soft w-40 h-40 border-4 border-white shadow-xl overflow-hidden animate-floaty">
              <img src={IMAGES.bath3} alt="Finished bathroom detail" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
